import { render, staticRenderFns } from "./PaymentReturn.vue?vue&type=template&id=7c46f5f8&scoped=true"
import script from "./PaymentReturn.vue?vue&type=script&lang=js"
export * from "./PaymentReturn.vue?vue&type=script&lang=js"
import style0 from "./PaymentReturn.vue?vue&type=style&index=0&id=7c46f5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46f5f8",
  null
  
)

export default component.exports